import { render } from "./ReservePublicIP.vue?vue&type=template&id=ab4680a6&scoped=true"
import script from "./ReservePublicIP.vue?vue&type=script&lang=js"
export * from "./ReservePublicIP.vue?vue&type=script&lang=js"

import "./ReservePublicIP.vue?vue&type=style&index=0&id=ab4680a6&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4680a6"]])

export default __exports__